<template>
  <div>
    <h4>Complaints</h4>

    <p v-if="message !== null">
      {{message}}
    </p>

    <template
      v-if="complaints !== null && complaints.length > 0"
    >
      <player-chat-block-complaint
        v-for="complaint in complaints"
        :key="complaint.id"
        :complaint="complaint"
      />
    </template>

  </div>
</template>

<script>
import PlayerChatBlockComplaint from './PlayerChatBlockComplaint.vue';

export default {
  name: 'PlayerChatBlockComplaints',

  components: {
    PlayerChatBlockComplaint,
  },

  props: {
    complaints: {
      type: Array,
      required: true,
    },
  },

  computed: {
    message() {
      const EMPTY_MESSAGE = 'No complaints';
      if(this.complaints === null) {
        return EMPTY_MESSAGE;
      }
      if(this.complaints.length === 0) {
        return EMPTY_MESSAGE;
      }
      return null;
    },
  },

};
</script>
